import { render, staticRenderFns } from "./DetailVacancy.vue?vue&type=template&id=644a2c01&scoped=true"
import script from "./DetailVacancy.vue?vue&type=script&lang=js"
export * from "./DetailVacancy.vue?vue&type=script&lang=js"
import style0 from "./DetailVacancy.vue?vue&type=style&index=0&id=644a2c01&prod&lang=scss&scoped=true"
import style1 from "./DetailVacancy.vue?vue&type=style&index=1&id=644a2c01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644a2c01",
  null
  
)

export default component.exports